import {
  Alert,
  AlertDescription,
  AlertIcon,
  Box,
  Button,
  Flex,
  Spacer,
  Text,
} from '@chakra-ui/react';
import { FormikProps } from 'formik';
import * as _ from 'lodash';
import React from 'react';

import { CreditAgreementWipDiffViewer } from './CreditAgreementWipDiffViewer';
import { SettingStickyHeader } from './SettingStickyHeader';
import { colors } from 'packages/common-frontend/colors';
import { Icon } from 'packages/common-frontend/components/icons';
import {
  UpdateCreditAgreementFullArtifactWipMutationFnGQLType,
  UpdateClientCreditAgreementFullArtifactWipMutationFnGQLType,
} from 'packages/creditAgreements/requests/requests.gql.generated';
import { CreditAgreement } from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/common';
import { CommitCreditAgreementWipButton } from 'packages/creditAgreements/ui/creditAgreementWip/CommitCreditAgreementWipButton';
import { SaveCreditAgreementWipButton } from 'packages/creditAgreements/ui/creditAgreementWip/SaveCreditAgreementWipButton';

type CreditAgreementWipStickyHeaderProps = {
  isWipDirty: boolean;
  isDiffOpen: boolean;
  setIsDiffOpen: (isOpen: boolean) => void;
  creditFacilityId: string;
  formProps: FormikProps<CreditAgreement.DomainEntity.CreditAgreementFullArtifact>;
  currentCreditAgreementFullArtifact: CreditAgreement.DomainEntity.CreditAgreementFullArtifact;
  // eslint-disable-next-line react/no-unused-prop-types
  artifactDocumentId: string | null;
  // eslint-disable-next-line react/no-unused-prop-types
  creditFacilitySlug: string;
  // eslint-disable-next-line react/no-unused-prop-types
  isJsonUploadOpen: boolean;
  // eslint-disable-next-line react/no-unused-prop-types
  setIsJsonUploadOpen: React.Dispatch<React.SetStateAction<boolean>>;
  operationMode: CreditAgreement.OperationMode;
  saveCreditAgreementFullArtifactWip:
    | UpdateClientCreditAgreementFullArtifactWipMutationFnGQLType
    | UpdateCreditAgreementFullArtifactWipMutationFnGQLType;
  isSaveCreditAgreementFullArtifactWipLoading: boolean;
  onCommitDone: () => void;
  isCommitAllowed?: boolean;
};
export const CreditAgreementWipStickyHeader = ({
  isWipDirty,
  isDiffOpen,
  setIsDiffOpen,
  formProps,
  currentCreditAgreementFullArtifact,
  saveCreditAgreementFullArtifactWip,
  isSaveCreditAgreementFullArtifactWipLoading,
  operationMode,
  creditFacilityId,
  onCommitDone,
  isCommitAllowed = true,
}: CreditAgreementWipStickyHeaderProps) => {
  return (
    <SettingStickyHeader>
      <>
        {/* Chakra doesn't natively support flex-gap */}
        <Flex alignItems="center" style={{ gap: '32px' }}>
          <Button
            border="2px"
            padding="10px 24px"
            backgroundColor="white"
            variant="ouline"
            colorScheme="aurora"
            onClick={() => setIsDiffOpen(!isDiffOpen)}
          >
            <Text color={colors.aurora[400]} mr="16px">
              {isDiffOpen ? 'Hide Changes' : 'Show Changes'}
            </Text>
            <Icon icon={isDiffOpen ? 'chevron-up' : 'chevron-down'} />
          </Button>
          <Spacer />
          <SaveCreditAgreementWipButton
            creditAgreementFullArtifactWip={formProps.values}
            isDisabled={!!_.keys(formProps.errors).length}
            saveCreditAgreementFullArtifactWip={
              saveCreditAgreementFullArtifactWip
            }
            isSaveCreditAgreementFullArtifactWipLoading={
              isSaveCreditAgreementFullArtifactWipLoading
            }
            operationMode={operationMode}
            isCommitAllowed={isCommitAllowed}
          />
          {isCommitAllowed && (
            <CommitCreditAgreementWipButton
              isDisabled={isWipDirty || !!_.keys(formProps.errors).length}
              creditFacilityId={creditFacilityId}
              operationMode={operationMode}
              onCommitDone={onCommitDone}
            />
          )}
        </Flex>
        {!!_.keys(formProps.errors).length && (
          <Alert status="warning" display="flex" w="fit-content">
            <AlertIcon />
            <AlertDescription>
              <Text>{JSON.stringify(formProps.errors)}</Text>
            </AlertDescription>
          </Alert>
        )}
        {isDiffOpen && (
          <Box mt="24px" maxHeight="70vh" overflowY="scroll">
            <CreditAgreementWipDiffViewer
              creditAgreementFullArtifactWip={formProps.values}
              currentCreditAgreementFullArtifact={
                currentCreditAgreementFullArtifact
              }
            />
          </Box>
        )}
      </>
    </SettingStickyHeader>
  );
};
